import React, { Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
  FeatureCard,
  Stats,
} from "../components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import Lottie from "react-lottie";
import SyncAltIcon from "@mui/icons-material/SyncAlt"; // For CI/CD
import CodeIcon from "@mui/icons-material/Code"; // For Infrastructure as Code
import MonitoringIcon from "@mui/icons-material/InsertChartOutlined"; // For Monitoring & Logging
import CloudIcon from "@mui/icons-material/Cloud"; // For Cloud Migration
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest"; // For DevOps Consulting
import SecurityIcon from "@mui/icons-material/Security";
import { Advantages, Collage, FAQSoft, OurProcess } from "./Sections";

export default function Devops() {
  useEffect(() => {}, []);

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <Hero
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          title="Why Hire Us for DevOps?"
          subtitle={
            <div>
              <p>
                Our DevOps expertise ensures seamless collaboration, faster
                delivery, and reliable software solutions. Here’s why we’re the
                right choice for your business:
              </p>
              {!state.auth.isMobile ? (
                <ul>
                  <li>
                    <strong>End-to-End Automation</strong>: We implement CI/CD
                    pipelines and Infrastructure as Code (IaC) to streamline
                    development, testing, and deployment processes.
                  </li>
                  <li>
                    <strong>Enhanced System Reliability</strong>: Our robust
                    monitoring and logging solutions ensure optimal performance
                    and quick issue resolution.
                  </li>
                  <li>
                    <strong>Collaborative Expertise</strong>: We foster teamwork
                    between development and operations, improving efficiency and
                    accelerating time-to-market.
                  </li>
                </ul>
              ) : (
                ""
              )}
              <p>
                By hiring us, you gain a partner dedicated to delivering
                scalable, reliable, and high-performing software solutions
                tailored to your needs.
              </p>
            </div>
          }
        />

        <ContentSideBySideInv
          title="Key Benefits of DevOps for Business"
          subtitle={
            <div style={{ marginLeft: "15px" }}>
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "orange",
                    marginRight: "15px",
                  }}
                />
                Accelerated Delivery
              </div>
              DevOps streamlines development and deployment processes, enabling faster 
              delivery of software updates and new features to meet market demands swiftly.
              <br />
              <br />
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "blue",
                    marginRight: "15px",
                  }}
                />
                Improved Collaboration
              </div>
              By fostering a culture of collaboration and communication between development and operations teams, 
              DevOps enhances overall efficiency and reduces bottlenecks.
              <br />
              <br />
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "teal",
                    marginRight: "15px",
                  }}
                />
                Increased Reliability
              </div>
              Continuous monitoring, automated testing, and rapid issue resolution in DevOps practices ensure higher system reliability and
               uptime, minimizing disruptions and enhancing customer satisfaction.
            </div>
          }
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/marketing (1).json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />
        <SpacerV height={"100px"} />
        <SpacerV height={"100px"} />
        <ThreeSideBySide
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          spacing={5}
          subtitle1={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"Continuous Integration & Delivery (CI/CD)"}
                text={
                  "We design and implement robust CI/CD pipelines to automate your software delivery process. Our solutions ensure faster, reliable, and error-free deployments, enabling your team to focus."
                }
                icon={
                  <SyncAltIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"Infrastructure as Code (IaC)"}
                text={`We leverage tools like Terraform and CloudFormation to automate infrastructure provisioning. Our IaC practices ensure consistency, scalability, and version control for your cloud and on-premise environments.`}
                icon={
                  <CodeIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle2={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"Monitoring & Logging"}
                text={`We implement comprehensive monitoring and logging solutions using tools like Prometheus, Grafana, and ELK Stack. Gain real-time insights into your systems, detect anomalies, and ensure optimal performance.`}
                icon={
                  <MonitoringIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"Cloud Migration"}
                text={`We help you seamlessly migrate to the cloud and optimize your cloud infrastructure for cost, performance, and security. Our experts ensure a smooth transition with minimal downtime.`}
                icon={
                  <CloudIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle3={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"DevOps Consulting"}
                text={`Our DevOps experts provide tailored strategies to transform your development and operations workflows. We align your processes with industry best practices to accelerate delivery and improve collaboration.`}
                icon={
                  <SettingsSuggestIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"Security & Compliance"}
                text={`We integrate security into every stage of your DevOps pipeline (DevSecOps). Our solutions ensure compliance with industry standards and protect your systems from vulnerabilities.`}
                icon={
                  <SecurityIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
        />
        <OurProcess
          invert
          step1={"Define Goals and Assess Current Infrastructure"}
          step1description={
            "The DevOps journey begins with defining clear goals, such as improving deployment frequency, reducing downtime, or enhancing collaboration between teams. We assess your current infrastructure, tools, and processes to identify bottlenecks and areas for improvement. This stage involves understanding your business needs and aligning them with DevOps best practices."
          }
          step2={"Design and Implement CI/CD Pipelines"}
          step2description={
            "We design and implement Continuous Integration and Continuous Delivery (CI/CD) pipelines to automate your software delivery process. This includes setting up tools like Jenkins, GitLab CI, or CircleCI to enable seamless code integration, automated testing, and deployment. The goal is to ensure faster, reliable, and error-free releases."
          }
          step3={"Automate Infrastructure and Monitoring"}
          step3description={
            "Using Infrastructure as Code (IaC) tools like Terraform or Ansible, we automate the provisioning and management of your infrastructure. Additionally, we set up monitoring and logging solutions (e.g., Prometheus, Grafana, ELK Stack) to provide real-time insights into system performance, detect anomalies, and ensure optimal uptime."
          }
          step4={"Continuous Improvement and Optimization"}
          step4description={
            "DevOps is an ongoing process. We continuously monitor and analyze system performance, gather feedback, and optimize workflows. This includes refining CI/CD pipelines, improving automation, and adopting new tools or practices to enhance efficiency, security, and scalability."
          }
        />
        <Advantages
          invert
          title="Advantages of DevOps"
          title1={"Faster Time-to-Market"}
          subtitle1={
            "DevOps enables more frequent software releases through automation and streamlined workflows, allowing businesses to respond quickly to market demands and deliver value faster."
          }
          title2={"Improved Collaboration"}
          subtitle2={
            "DevOps fosters a culture of collaboration between development and operations teams, breaking down silos and improving communication for efficient workflows, faster issue resolution, and better alignment with business goals."
          }
          title3={"Enhanced Stability"}
          subtitle3={
            "With automated testing, continuous monitoring, and proactive issue detection, DevOps ensures systems are more stable and reliable, reducing downtime and improving user satisfaction."
          }
          title4={"Scalability and Cost Efficiency"}
          subtitle4={
            "DevOps practices like Infrastructure as Code (IaC) and cloud optimization enable efficient scaling of infrastructure, reducing manual effort, leading to cost savings and better resource utilization."
          }
        />
        <Stats />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
